export default "__VITE_ASSET__f81eb51b__"